import {BaseHook, Hook, HookClass, NickProcessArtfact} from '@mrp-brasil/nick-process-commons';
import {from, Observable, of} from 'rxjs';
import {concatMap, map} from 'rxjs/operators';
import {ArtfactKind} from '@mrp-brasil/nick-data-commons';
import { createClientAsync, Client } from 'soap';
import {AllHtmlEntities} from 'html-entities';

@HookClass('soap')
export class SoapHook extends BaseHook {

    @Hook('c2b022fb-bef6-401b-8411-822af9c437bc')
    public soap(inputArtifact: NickProcessArtfact): Observable<NickProcessArtfact> {
        return from(createClientAsync(inputArtifact.object.config.url))
            .pipe(concatMap((client: Client) => {
                return from(client[`${inputArtifact.object.config.function}Async`](inputArtifact.object.data));
            }))
            .pipe(map((result: any) => {
                const resultArtifact = new NickProcessArtfact();
                resultArtifact.kind = ArtfactKind.ANY;
                if (result) {
                    const entities = new AllHtmlEntities();

                    if (inputArtifact.object.config?.attr) {
                        const fields = inputArtifact.object.config.attr.split('.');
                        resultArtifact.object = fields.reduce((o: any, i: any) => (o ? o[i] : o), result[0]);
                        if (inputArtifact.object.config?.decode)
                            resultArtifact.object = JSON.parse(entities.decode(resultArtifact.object));
                        return resultArtifact;

                    }

                    resultArtifact.object = JSON.parse(entities.decode(result[0].return));
                }
                return resultArtifact;
            }));
    }

}
